import { custom } from 'utils/Api';
import { filter, floor, get } from 'lodash';

import { REQUEST_UNION, REQUEST_UNION_FAILURE, REQUEST_UNION_SUCCESS, REQUEST_EMPLOYEE_UNION, REQUEST_EMPLOYEE_UNION_FAILURE, REQUEST_EMPLOYEE_UNION_SUCCESS, REQUEST_PENSION, REQUEST_PENSION_FAILURE, REQUEST_PENSION_SUCCESS } from 'constants/ActionTypes';
import moment from 'moment';

const requestUnion = () => ({
  type: REQUEST_UNION
});

const requestUnionSuccess = unions => ({
  type: REQUEST_UNION_SUCCESS,
  unions
});

const requestUnionFailure = error => ({
  type: REQUEST_UNION_FAILURE,
  error
});

export const fetchUnionData = employeeDetailId => (dispatch, getState) => {
  dispatch(requestUnion());
  const {
    loginReducer: {
      user: { token }
    }
  } = getState();

  const config = {
    headers: { Authorization: `Bearer ${token}` },
    method: 'GET',
    url: `/kjarni/api/v2/EmployeeDetailUnions(${employeeDetailId})/PayUnionDetail`
  };

  return custom(config)
    .then(({ data }) => {
      dispatch(requestUnionSuccess(data.value));
    })
    .catch(err => dispatch(requestUnionFailure(err)));
};

const requestEmployeeUnion = () => ({
  type: REQUEST_EMPLOYEE_UNION
});

const requestEmployeeUnionSuccess = employeeUnions => ({
  type: REQUEST_EMPLOYEE_UNION_SUCCESS,
  employeeUnions
});

const requestEmployeeUnionFailure = error => ({
  type: REQUEST_EMPLOYEE_UNION_FAILURE,
  error
});

export const fetchEmployeeUnionData = employeeDetailId => (dispatch, getState) => {
  dispatch(requestEmployeeUnion());
  const {
    loginReducer: {
      user: { token }
    }
  } = getState();

  const config = {
    headers: { Authorization: `Bearer ${token}` },
    method: 'GET',
    url: `/kjarni/api/v2/EmployeeDetailUnions(${employeeDetailId})/EmployeeUnionDetail`
  };

  return custom(config)
    .then(({ data }) => {
      dispatch(requestEmployeeUnionSuccess(data.value));
    })
    .catch(err => dispatch(requestEmployeeUnionFailure(err)));
};

const requestPension = () => ({
  type: REQUEST_PENSION
});

const requestPensionSuccess = data => ({
  type: REQUEST_PENSION_SUCCESS,
  data
});

const requestPensionFailure = error => ({
  type: REQUEST_PENSION_FAILURE,
  error
});

export const fetchPensionData = employeeDetailId => async (dispatch, getState) => {
  dispatch(requestPension());

  const { loginReducer: { user: { token } } } = getState();

  const pensionConfig = {
    headers: { Authorization: `Bearer ${token}` },
    method: 'GET',
    url: `/kjarni/api/v2/EmployeeDetailPensions(${employeeDetailId})/PensionDetail`
  };

  const getEmployeeMasterPensionsByMasterID = {
    headers: { Authorization: `Bearer ${token}` },
    method: 'GET',
    url: `/kjarni/api/v2/EmployeeMasterPensions(${floor(employeeDetailId / 10, 0)})/PensionDetail`
  };

  const getXapValue = {
    url: '/kjarni/api/v2/XapValues',
    method: 'GET',
    params: {
      $filter: 'XapValueName eq \'Pay.Use.EmployeePension.Private\''
    }
  };

  try {
    const pension = get(await custom(pensionConfig), 'data');

    const useMasterPension = get(await custom(getXapValue), 'data.value[0].Value', null) === 'true';

    const privateMasterPensions = useMasterPension && get(await custom(getEmployeeMasterPensionsByMasterID), 'data.value', []);
    const General = filter(get(pension, 'General'), p => moment().isBetween(moment(p.Begda), moment(p.Endda)));
    const Private = filter(useMasterPension ? privateMasterPensions : get(pension, 'Private', []), p => moment().isBetween(moment(p.Begda), moment(p.Endda)));

    dispatch(requestPensionSuccess({ General, Private }));

  } catch (error) {
    dispatch(requestPensionFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/actions/EmployeePensionAndUnion.js